import moment from "moment";

export class DateHelper {

    public static ServerDate(date: Date): string {
        return moment(date).format('YYYY-MM-DDTHH:mm:ssZ');
    }

    public static Pretty(date: Date|string|undefined): string {
        if (date === undefined) {
            return "";
        } else if (typeof date === 'string') {
            return moment(new Date(Date.parse(date))).format('DD/MM-YY');
        } else {
            return moment(date).format('DD/MM-YY');
        }
    }

    public static Week(date: Date|string|undefined): number {
        if (date === undefined) {
            return 0;
        } else if (typeof date === 'string') {
            return moment(new Date(Date.parse(date))).week();
        } else {
            return moment(date).week();
        }
    }

}
